module.exports = __webpack_public_path__ + "img/placeholder-portrait.5a32aec.jpg";